import i18n, { DEFAULT_LOCALE, TranslatedLanguage } from '@/utils/i18n';
import { captureException } from './sentry';

export type Translation = string | Partial<Record<TranslatedLanguage, string>>;

const TRANSLATED_LANGUAGE_MAP = new Map(
  Object.values(TranslatedLanguage).map((l) => [l.toString(), l]),
);

export const formatLocale = (locale: string) => {
  return locale.replace('_', '-');
};

export const getTranslationValue = (translation: Translation): string => {
  if (typeof translation === 'string') {
    return translation;
  }

  const languageParts = formatLocale(i18n.locale).split('-');
  const language = TRANSLATED_LANGUAGE_MAP.get(languageParts[0]);
  const value =
    (language && translation[language]) ||
    // Fall back to translation value for default locale
    translation[DEFAULT_LOCALE] ||
    // Fall back to an empty string
    '';

  // Empty in every locale means intentionally blank - only report when some
  // locale has text but we still failed to resolve a value
  if (!value && Object.values(translation).some(Boolean)) {
    captureException(new Error('Unable to get translation'), {
      extra: {
        locale: i18n.locale,
        translation,
      },
    });
  }

  return value;
};

export const sanitizeTranslation = (translation: Translation): Translation => {
  if (!translation || Object.keys(translation).length === 0) {
    return '';
  }

  return translation;
};
